import EntityType from '@enums/EntityType';

export default function unassignedPerson() {
  return {
    avatar: null,
    first_name: 'Unassigned',
    last_name: '',
    uuid: EntityType.UNASSIGNED,
    name: 'Unassigned',
    __type: EntityType.PERSON,
  };
}
